import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { gray } from '@css/constants'

export const TRANSITION_DELAY = 400

export const ExpanderWrapper = styled('div')(css``)

export const Heading = styled('div')(css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`)

export const ChevronIconWrapper = styled('div')<{ isOpen: boolean }>(props => css`
  display: flex;

  & > svg {
    cursor: pointer;
    transition: transform ${TRANSITION_DELAY}ms ease;
    vertical-align: middle;
    transform: rotate(${props.isOpen ? 90 : -90}deg);
    color: ${gray};
  }
`)

export const PlusIconWrapper = styled('div')(css`
  display: flex;
`)

export const ExpandedContent = styled('div')<{ state: 'entered' | 'entering' | 'exited' }>(props => css`
  overflow: hidden;
  transition: height ${TRANSITION_DELAY}ms ease, opacity ${TRANSITION_DELAY}ms ease;
  opacity: ${props.state === 'entered' || props.state === 'entering' ? 1 : 0};
  height: ${props.state === 'entered' ? 'auto' : 0};
`)

export const chevronBtnStyles = css`
  display: inline-flex;
  height: 28px;
  width: 28px;
  margin-left: 10px;
`
